<template>
    <div id="app">
        <MainNavbar />
        <HeroComponent />
        <SiteStatistics />
        <ServiceList />
        <ExpertTeam />
        <SiteFooter />
    </div>
</template>

<script>
import MainNavbar from './Navbar.vue'
import HeroComponent from './Hero.vue'
import SiteStatistics from './Statistics.vue'
import ServiceList from './Services.vue'
import ExpertTeam from './Team.vue'
import SiteFooter from './Footer.vue'

export default {
    name: 'DemoComponent',
    components: {
        MainNavbar,
        HeroComponent,
        SiteStatistics,
        ServiceList,
        ExpertTeam,
        SiteFooter
    }
}
</script>

<style scoped>
/* ... existing code ... */
</style>